import { defineTokens } from "@chakra-ui/react-v3";

export const colors = defineTokens.colors({
  white: { value: "#ffffff" },
  black: { value: "#18181C" },

  whiteAlpha: {
    0: { value: "#ffffff00" },
    50: { value: "#ffffff0a" },
    100: { value: "#ffffff0f" },
    200: { value: "#ffffff14" },
    300: { value: "#ffffff29" },
    400: { value: "#ffffff3d" },
    500: { value: "#ffffff5c" },
    600: { value: "#ffffff7a" },
    700: { value: "#ffffffa3" },
    800: { value: "#ffffffcc" },
    900: { value: "#ffffffeb" },
    950: { value: "#fffffff2" },
  },

  blackAlpha: {
    0: { value: "#18181C00" },
    50: { value: "#18181C0A" },
    100: { value: "#18181C0F" },
    200: { value: "#18181C14" },
    300: { value: "#18181C29" },
    400: { value: "#18181C3D" },
    500: { value: "#18181C5C" },
    600: { value: "#18181C7A" },
    700: { value: "#18181CA3" },
    800: { value: "#18181CCC" },
    900: { value: "#18181CEB" },
    950: { value: "#18181CF2" },
  },

  gray: {
    50: { value: "#F9F9FA" },
    100: { value: "#EEEEF1" },
    200: { value: "#DDDDE3" },
    300: { value: "#C8C8D1" },
    400: { value: "#A9A9BB" },
    500: { value: "#87879F" },
    600: { value: "#6B6B82" },
    700: { value: "#505064" },
    800: { value: "#3A3A4D" },
    900: { value: "#2A2A3D" },
    950: { value: "#202026" },
  },

  sky: {
    50: { value: "#E6F3FF" },
    100: { value: "#D0E8FF" },
    200: { value: "#B8DDFF" },
    300: { value: "#99CEFF" },
    400: { value: "#63B0F7" },
    500: { value: "#298DE9" },
    600: { value: "#0E71CC" },
    700: { value: "#0B5EAB" },
    800: { value: "#084073" },
    900: { value: "#1F374E" },
    950: { value: "#04182B" },
  },

  aqua: {
    50: { value: "#ECFDFE" },
    100: { value: "#D4FAFC" },
    200: { value: "#A4F4F9" },
    300: { value: "#70EFF5" },
    400: { value: "#10D6E0" },
    500: { value: "#0EBAC3" },
    600: { value: "#0C9AA2" },
    700: { value: "#087277" },
    800: { value: "#05494C" },
    900: { value: "#122E2F" },
    950: { value: "#0B191A" },
  },

  green: {
    50: { value: "#F0FCF9" },
    100: { value: "#E3F7F2" },
    200: { value: "#B8E5DA" },
    300: { value: "#80DBC5" },
    400: { value: "#44BD9F" },
    500: { value: "#00B287" },
    600: { value: "#008F6B" },
    700: { value: "#00644B" },
    800: { value: "#044333" },
    900: { value: "#18302A" },
    950: { value: "#011B15" },
  },

  electricYellow: {
    50: { value: "#FBFCEE" },
    100: { value: "#F4F7C9" },
    200: { value: "#F0F5B2" },
    300: { value: "#F1F98B" },
    400: { value: "#F0FB6A" },
    500: { value: "#EFFF33" },
    600: { value: "#D8E90C" },
    700: { value: "#929E0A" },
    800: { value: "#4A4F17" },
    900: { value: "#18302A" },
    950: { value: "#1A1C02" },
  },

  sand: {
    50: { value: "#FEFAF3" },
    100: { value: "#FFF1DA" },
    200: { value: "#FFE2B0" },
    300: { value: "#F5CA7F" },
    400: { value: "#F2B347" },
    500: { value: "#F2A521" },
    600: { value: "#DE8D00" },
    700: { value: "#85590D" },
    800: { value: "#513C17" },
    900: { value: "#41331A" },
    950: { value: "#281C07" },
  },

  red: {
    50: { value: "#FFF4F1" },
    100: { value: "#FFEAE4" },
    200: { value: "#FFD9CE" },
    300: { value: "#FFBEAB" },
    400: { value: "#FF8965" },
    500: { value: "#FF5B29" },
    600: { value: "#E94716" },
    700: { value: "#A33B1B" },
    800: { value: "#733522" },
    900: { value: "#4B291E" },
    950: { value: "#2A0F07" },
  },

  pink: {
    50: { value: "#FFF5FB" },
    100: { value: "#FDE9F5" },
    200: { value: "#FED2EC" },
    300: { value: "#FCB3DF" },
    400: { value: "#F883C9" },
    500: { value: "#FA53B7" },
    600: { value: "#D7479D" },
    700: { value: "#B24D8A" },
    800: { value: "#6C234F" },
    900: { value: "#481935" },
    950: { value: "#280E1E" },
  },

  purple: {
    50: { value: "#F9F5FF" },
    100: { value: "#EDE2FF" },
    200: { value: "#DCC6FF" },
    300: { value: "#CBAAFF" },
    400: { value: "#B98CFF" },
    500: { value: "#A871FF" },
    600: { value: "#8652D9" },
    700: { value: "#7042BB" },
    800: { value: "#4B2E7A" },
    900: { value: "#32214E" },
    950: { value: "#1C112D" },
  },

  indigo: {
    50: { value: "#F5F5FF" },
    100: { value: "#EDEEFF" },
    200: { value: "#CED0FF" },
    300: { value: "#B3B6FF" },
    400: { value: "#8F93F9" },
    500: { value: "#666BFF" },
    600: { value: "#484EFF" },
    700: { value: "#3D4270" },
    800: { value: "#2D3159" },
    900: { value: "#262B47" },
    950: { value: "#1A1926" },
  },
});
